import { createSelector } from 'reselect';

export function getTeamsTopTalents(state) {
  return state.teamsTopTalents;
}

export function getTeamTopTalentsById(state, teamsId) {
  return getTeamsTopTalents(state).get(teamsId);
}

//=====================================
//  MEMOIZED SELECTORS
//-------------------------------------

export const getCurrentTeamTopTalents = createSelector(
  getTeamsTopTalents,
  teams_top_talents => teams_top_talents.get(teams_top_talents.get('currentTeamId'))
);
